<script lang="ts">
  import type { Contributions } from "$types";
  import { page } from "$app/stores";
  import Meta from "$lib/components/meta/MetaUserGalleryContribution.svelte";
  // view components
  import Dialog from "$components/modals/Dialog.svelte";

  // for meta tags
  $: cont_index = $page?.data?.contributions?.findIndex(
    (item: Contributions) => item.image === $page.data.id,
  );
</script>

<Dialog
  is_community={true}
  gallery={$page.data.contributions}
  title="Craft Roulette"
  subtitle="Community Curated Gallery"
  discussions={undefined}
>
  {#if $page.data.contributions}
    {#key cont_index}
      <Meta
        contribution={$page.data.contributions[cont_index]}
        id={$page.data.uuid}
      />
    {/key}
  {/if}
</Dialog>
